import React from 'react';
import { FormattedMessage, FormattedCurrency } from 'i18n';
import ReactPlaceholder from 'react-placeholder';
import styled from 'styled-components';

import Placeholder from './Placeholder';
import truncate from 'styles/utils/truncate';

export default function PackagePriceComponentTravelSummaryBar({ ready, pricePerPerson }) {
  return (
    <ReactPlaceholder ready={ready} showLoadingAnimation customPlaceholder={<Placeholder />}>
      <Root>
        <FormattedCurrency value={pricePerPerson} />
        &nbsp;
        <PricePerPersonLabel>
          <FormattedMessage id={'perPerson.label'} description={'per person'} defaultMessage={'per person'} />
        </PricePerPersonLabel>
      </Root>
    </ReactPlaceholder>
  );
}
const Root = styled.div`
  position: relative;
`;

const PricePerPersonLabel = styled.div`
  position: absolute;
  font-size: 12px;
  text-transform: lowercase;
  font-style: italic;
  color: ${({ theme }) => theme.colors.text.light};
  ${truncate()}
`;
